import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { useBatch } from 'hooks/queries/batches/useBatch'
import { useQueryClient } from 'react-query'
import { removeFileDetailCache } from 'hooks/queries/files/cacheUtils'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'

interface UsePollDesignReplacementOptions {
  replaceFrameBatchId?: string
  onComplete?: () => void
  scheduledPostId?: number
  designKey: string
}

export const usePollDesignReplacement = ({
  replaceFrameBatchId,
  onComplete,
  scheduledPostId,
  designKey,
}: UsePollDesignReplacementOptions) => {
  const queryClient = useQueryClient()
  const workspaceId = useCurrentWorkspaceId()

  const { data: replaceFrameBatchData } = useBatch(replaceFrameBatchId, {
    pollUntilFinal: true,
    onComplete: () => {
      onComplete?.()

      if (replaceFrameBatchData && replaceFrameBatchData.failures > 0) {
        showToastMessage('Failed to replace design', 'error')
        return
      }

      queryClient.invalidateQueries(['calendarItems'])
      queryClient.invalidateQueries(['calendar'])
      queryClient.invalidateQueries(['files'])
      if (scheduledPostId) {
        queryClient.invalidateQueries(['scheduledPosts', scheduledPostId])
      }
      removeFileDetailCache(queryClient, workspaceId, designKey)
    },
  })
}
